import { TRequestorFill, TRequestorFillForm } from '../models'

export const mapRequestorFillFormToDB = (props: TRequestorFillForm): Partial<TRequestorFill> => ({
  ...props,
  BigDealEnablement: props.BigDealEnablement || null,
  HPSigningEntity: props.HPSigningEntity ? props.HPSigningEntity.replace('&amp;', '&') : null,
  TerritorySale: props.TerritorySale.length ? props.TerritorySale.join(',') : '',
  TerritorySaleISO: props.TerritorySaleISO.length ? props.TerritorySaleISO.join(',') : '',
})
